import { ContentRole, IDocument } from "@vp/models";

export interface ContentData extends IDocument {
  contentId: string; // KEY
  friendlyId: string;
  displayName: string;
  description: string;
  active: boolean;
  roles: ContentRole[];
  permissionTags: string[];
  content: string;
  emailSubject: string;
  file: ContentFile;
  tags: string[];
  contentTypeId: string;
  isPublic: boolean;
  createdBy: string;
  path: string;
  severity?: SeverityLevel;
  schedule?: ScheduleInfo;
}

export enum SeverityLevel {
  Informational,
  Warning,
  Emergency
}

export interface ScheduleInfo {
  start?: string;
  end?: string;
}

export interface ContentFile {
  fileName: string;
  url: string | null;
  fileTextBase64: string;
}
